'use client';
import { useQueryClient } from '@tanstack/react-query';

import { ProductDataV2 } from '~/apis/search';

export const useUpdateInfiniteQueryProductFavorite = () => {
  const queryClient = useQueryClient();
  const updateInfiniteQueryProductFavorite = ({
    queryKey,
    pid,
    isFavorite,
  }: {
    queryKey: (string | object)[];
    pid: number;
    isFavorite: boolean;
  }) => {
    queryClient.setQueryData(
      queryKey,
      (prev: { pages: { data: ProductDataV2[] }[]; pageParams: { page: number }[] }) => {
        return {
          pages: prev?.pages.map((page) => {
            return {
              ...page,
              data: page.data?.map((product: ProductDataV2) => {
                return {
                  ...product,
                  faved: product.pid === pid ? isFavorite : product.faved,
                };
              }),
            };
          }),
          pageParams: prev?.pageParams,
        };
      },
    );
  };

  return {
    updateInfiniteQueryProductFavorite,
  };
};
